export default __webpack_public_path__ + "static/media/fire-tv.9c0a479d.svg";